// extracted by mini-css-extract-plugin
export default {"banner":"JobPostPage_banner__EGGC9","cnt":"JobPostPage_cnt__mLeBD","bannerBtn":"JobPostPage_bannerBtn__1kbhc","icon":"JobPostPage_icon__pEk3U","req":"JobPostPage_req__YjDC6"};